import { memo } from 'react';
import { Box } from '@bonanza-social/moonlight';

import { LevelHeaderItem } from '@bonanza-social/levels';
import { StatusHeaderItem } from '@bonanza-social/status';
import { InboxHeaderItem } from '@bonanza-social/inbox';
import MainHeaderCTA from './MainHeaderCTA';
import CoinBalanceHeaderItem from '../../CoinBalanceHeaderItem/CoinBalanceHeaderItem';
import LinkedBonanzaLogo from '../../LinkedBonanzaLogo';

function DesktopMainHeader() {
  return (
    <Box
      flex={1}
      flexDirection="row"
      paddingHorizontal="space-1000"
      paddingVertical="space-400"
      gap="space-200"
    >
      <Box marginRight="space-1000" centerContent>
        <LinkedBonanzaLogo />
      </Box>
      <LevelHeaderItem flex={1} />
      <StatusHeaderItem flex={1} />
      <InboxHeaderItem />
      <CoinBalanceHeaderItem />
      <MainHeaderCTA maxWidth={250} />
    </Box>
  );
}

export default memo(DesktopMainHeader);
